// ZoomToggleButton — Pill toggle for Na-Ion Ragone zoom state

/**
 * @param {Object} props
 * @param {'all'|'focused'} props.zoomState - Current zoom state
 * @param {Function} props.onChange - Callback with new zoom state
 */
export default function ZoomToggleButton({ zoomState, onChange }) {
  return (
    <div className="zoom-toggle">
      <button
        className={`zoom-toggle__btn ${zoomState === 'all' ? 'zoom-toggle__btn--active' : ''}`}
        onClick={() => onChange('all')}
      >
        All Cells
      </button>
      <button
        className={`zoom-toggle__btn ${zoomState === 'focused' ? 'zoom-toggle__btn--active' : ''}`}
        onClick={() => onChange('focused')}
      >
        Na-Ion vs LFP
      </button>
    </div>
  )
}
